import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Observable, Subscription} from 'rxjs';
import {Store} from '@ngrx/store';
import {AppState, selectAuthState, selectDoctorState} from '../../../../store/app.states';
import {DoctorService} from '../../../../services/doctor.service';
import {Chart} from 'chart.js';
import {MatTableDataSource} from '@angular/material/table';
import {Patient} from '../../../../model/user/Patient';
import {MatPaginator, PageEvent} from '@angular/material/paginator';
import {Router} from '@angular/router';

@Component({
  selector: 'app-bar-chart-stable-unstable-crohn',
  templateUrl: './bar-chart-stable-unstable-crohn.component.html',
  styleUrls: ['./bar-chart-stable-unstable-crohn.component.css']
})
export class BarChartStableUnstableCrohnComponent implements OnInit, OnDestroy {
  getAuthState: Observable<any>;
  getDoctorState: Observable<any>;
  isAuthenticated: boolean;
  user = null;
  errorMessage = null;
  subscription: Subscription;
  subscription1: Subscription;
  title = "Pazienti stabili/instabili";
  destination = 'general-status';
  isDataAvailable = false;
  // ******************************************************************************************************************
  // bar chart dei pazienti globali malati di Crohn in miglioramento, in peggioramento, stabili
  // ******************************************************************************************************************
  stabiliRemissioneCrohn = [];
  stabiliLieveCrohn = [];
  stabiliModerataCrohn = [];
  stabiliGraveCrohn = [];
  instabiliPegRemissioneCrohn = [];
  instabiliPegLieveCrohn = [];
  instabiliPegModerataCrohn = [];
  instabiliPegGraveCrohn = [];
  instabiliMiglRemissioneCrohn = [];
  instabiliMiglLieveCrohn = [];
  instabiliMiglModerataCrohn = [];
  instabiliMiglGraveCrohn = [];
  // arrays
  CrohnRemissioneArray = [];
  CrohnLieveArray = [];
  CrohnModerataArray = [];
  CrohnGraveArray = [];
  //
  //
  dataSource;
  headElements = ['name', 'surname', 'card', 'questionnaire', 'email', 'chat'];
  totalSize = 0;
  // stable and unstable UC patients bar chart
  canvas: any;
  ctx: any;
  myChartCrohnStableUnstable: Chart;
  // TABELLE DISPONIBILI PER LE SITUAZIONI GRAVI
  isHovered = false;
  isTableStabiliGraviAvailable = false;
  isTableStabiliLieveAvailable = false;
  isTableStabiliModerataAvailable = false;
  isTableStabiliRemissioneAvailable = false;
  isTableMiglGraviAvailable = false;
  isTableMiglLieveAvailable = false;
  isTableMiglModerataAvaialble = false;
  isTableMiglRemissioneAvailable = false;
  isTablePegGraviAvailable = false;
  isTablePegLieveAvailable = false;
  isTablePegModerataAvailable = false;
  isTablePegRemissioneAvailable = false;
  TableTitle: string;
  // paginator della tabella
  public pageSize = 5;
  public currentPage = 0;
  public tasks: any[];
  //
  public barChartCrohnStableUnstableOptions = {
    scaleShowVerticalLines: false,
    responsive: true,
    scales: {
      xAxes: [{
        display: true,
        stacked: true,
        barThickness: 70,  // number (pixels) or 'flex'
        ticks: {
          fontSize: 12,
          fontStyle: 'bold',
          fontFamily: 'Helvetica',
          fontColor: '#006192'
        }
      }],
      yAxes: [{
        display: true,
        stacked: true,
        barThickness: 70,  // number (pixels) or 'flex'
        ticks: {
          fontSize: 12,
          fontStyle: 'bold',
          fontFamily: 'Helvetica',
          fontColor: '#006192'
        }
      }],
    },
    legend: {
      display: true,
      position: 'top',
      align: 'center',
      textDirection: 'ltr',
      labels: {
        usePointStyle: true,
        fontColor: '#006192',
        fontSize: 14,
        fontFamily: 'Helvetica',
      }
    },
    tooltips: {
      backgroundColor: '#1c1c1c',
      titleColor: '#f0d7f7',
      bodyFontSize: 16,
      titleFontSize: 18,
      cornerRadius: 5,
      caretPadding: 10
    },
    title: {
      display: true,
      text: 'Malattia di Crohn - n° di pazienti stabili e instabili',
      fontColor: '#006192',
      fontSize: 20,
      fontFamily: 'Helvetica',
    },
    hover: {
      mode: 'nearest',
      intersect: true
    }
  };
  public barChartCrohnStableUnstableType = 'bar';
  public barChartCrohnStableUnstableLabels = ['STABILI', 'IN MIGLIORAMENTO', 'IN PEGGIORAMENTO'];
  public barChartCrohnStableUnstableLegend = true;
  public barChartCrohnStableUnstableData = [{
    data: this.CrohnGraveArray,
    barThickness: 70,  // number (pixels) or 'flex'
    backgroundColor: ['#ff5232', '#ff5232', '#ff5232'],
    hoverBackgroundColor: ['#d11507', '#d11507', '#d11507'],
    label: 'ATTIVITA GRAVE',
    /*datalabels: {
      color: 'white', // Color for percentage value
    }*/
  }, {
    data: this.CrohnModerataArray,
    barThickness: 70,  // number (pixels) or 'flex'
    backgroundColor: ['#ffb769', '#ffb769', '#ffb769'],
    hoverBackgroundColor: ['#ff7b5a', '#ff7b5a', '#ff7b5a'],
    label: 'ATTIVITA MODERATA',
    /*datalabels: {
      color: 'white', // Color for percentage value
    }*/
  }, {
    data: this.CrohnLieveArray,
    barThickness: 70,  // number (pixels) or 'flex'
    backgroundColor: ['#ffd491', '#ffd491', '#ffd491'],
    hoverBackgroundColor: ['#ef8800', '#ef8800', '#ef8800'],
    label: 'ATTIVITA LIEVE',
    /*datalabels: {
      color: 'white', // Color for percentage value
    }*/
  }, {
    data: this.CrohnRemissioneArray,
    barThickness: 70,  // number (pixels) or 'flex'
    backgroundColor: ['#a1e19e', '#a1e19e', '#a1e19e'],
    hoverBackgroundColor: ['#03c03c', '#03c03c', '#03c03c'],
    label: 'REMISSIONE',
    /*datalabels: {
      color: 'white' // Color for percentage value}
    }*/
  }];
  @ViewChild(MatPaginator, {static: false}) set matPaginator(paginator: MatPaginator) {
    if (paginator) {
      paginator._intl.itemsPerPageLabel = 'Pazienti per pagina';
      paginator._intl.previousPageLabel = 'Pagina precedente';
      paginator._intl.nextPageLabel = 'Pagina successiva';
    }
  }
  constructor(private store: Store<AppState>,
              private doctorService: DoctorService,
              private router: Router) {
    this.getAuthState = this.store.select(selectAuthState);
    this.getDoctorState = this.store.select(selectDoctorState);
  }
  ngOnInit(): void {
    this.subscription1 = this.getAuthState.subscribe((state) => {
      this.isAuthenticated = state.isAuthenticated;
      this.user = JSON.parse(localStorage.getItem('user'));
      this.errorMessage = state.errorMessage;
      this.retrieveCrohnStableAndUnstable();
    });
  }
  ngOnDestroy(): void {
    this.subscription.unsubscribe();
    this.subscription1.unsubscribe();
  }
  // pazienti stabili e instabili globali malati di Crohn
  retrieveCrohnStableAndUnstable() {
    // prendo dal database il numero di tutti i pazienti che soffrono di altro del singolo dottore
    this.subscription = this.doctorService.getCrohnStableAndUnstable().subscribe(
      dictionary => {
        // controllo che i numeri siano messi correttamente
        console.log(dictionary);
        this.stabiliGraveCrohn = Object.values(dictionary)[0].StabiliGrave;
        this.stabiliModerataCrohn = Object.values(dictionary)[1].StabiliModerata;
        this.stabiliLieveCrohn = Object.values(dictionary)[2].StabiliLieve;
        this.stabiliRemissioneCrohn = Object.values(dictionary)[3].StabiliRemissione;
        this.instabiliMiglGraveCrohn = Object.values(dictionary)[4].InstabiliMiglGrave;
        this.instabiliMiglModerataCrohn = Object.values(dictionary)[5].InstabiliMiglModerata;
        this.instabiliMiglLieveCrohn = Object.values(dictionary)[6].InstabiliMiglLieve;
        this.instabiliMiglRemissioneCrohn = Object.values(dictionary)[7].InstabiliMiglRemissione;
        this.instabiliPegGraveCrohn = Object.values(dictionary)[8].InstabiliPegGrave;
        this.instabiliPegModerataCrohn = Object.values(dictionary)[9].InstabiliPegModerata;
        this.instabiliPegLieveCrohn = Object.values(dictionary)[10].InstabiliPegLieve;
        this.instabiliPegRemissioneCrohn = Object.values(dictionary)[11].InstabiliPegRemissione;
        // riempio il vettore della categoria 'Remissione'
        this.CrohnRemissioneArray.push(this.stabiliRemissioneCrohn.length);
        this.CrohnRemissioneArray.push(this.instabiliMiglRemissioneCrohn.length);
        this.CrohnRemissioneArray.push(this.instabiliPegRemissioneCrohn.length);
        // riempio il vettore della categoria 'Lieve'
        this.CrohnLieveArray.push(this.stabiliLieveCrohn.length);
        this.CrohnLieveArray.push(this.instabiliMiglLieveCrohn.length);
        this.CrohnLieveArray.push(this.instabiliPegLieveCrohn.length);
        // riempio il vettore della categoria 'Moderata'
        this.CrohnModerataArray.push(this.stabiliModerataCrohn.length);
        this.CrohnModerataArray.push(this.instabiliMiglModerataCrohn.length);
        this.CrohnModerataArray.push(this.instabiliPegModerataCrohn.length);
        // riempio il vettore della categoria 'Grave'
        this.CrohnGraveArray.push(this.stabiliGraveCrohn.length);
        this.CrohnGraveArray.push(this.instabiliMiglGraveCrohn.length);
        this.CrohnGraveArray.push(this.instabiliPegGraveCrohn.length);
        // creo il grafico bar chart
        this.canvas = document.getElementById('myChartCrohnStableUnstable') as HTMLCanvasElement;
        this.ctx = this.canvas.getContext('2d');
        this.myChartCrohnStableUnstable = new Chart(this.ctx, {
          type: this.barChartCrohnStableUnstableType,
          data: {
            labels: this.barChartCrohnStableUnstableLabels,
            datasets: this.barChartCrohnStableUnstableData,
          },
          options: {
            responsive: true,
            onClick: event => {
              this.doctorService.getGlobalPatients().subscribe((patients) => {
                localStorage.setItem('patients', JSON.stringify(patients));
              });
              if (this.myChartCrohnStableUnstable.getElementAtEvent(event).length > 0) {
                if (this.myChartCrohnStableUnstable.getElementAtEvent(event)[0]['_model'].datasetLabel === 'ATTIVITA GRAVE'
                  && this.myChartCrohnStableUnstable.getElementAtEvent(event)[0]['_model'].label === 'STABILI') {
                  // setto le altre due tabelle invisibili
                  this.isTablePegGraviAvailable = false;
                  this.isTablePegRemissioneAvailable = false;
                  this.isTablePegModerataAvailable = false;
                  this.isTablePegLieveAvailable = false;
                  this.isTableMiglGraviAvailable = false;
                  this.isTableMiglLieveAvailable = false;
                  this.isTableMiglModerataAvaialble = false;
                  this.isTableMiglRemissioneAvailable = false;
                  this.isTableStabiliLieveAvailable = false;
                  this.isTableStabiliModerataAvailable = false;
                  this.isTableStabiliRemissioneAvailable = false;
                  this.showTableStabiliGrave(); // mostro la tabella
                } else if (this.myChartCrohnStableUnstable.getElementAtEvent(event)[0]['_model'].datasetLabel === 'ATTIVITA MODERATA'
                  && this.myChartCrohnStableUnstable.getElementAtEvent(event)[0]['_model'].label === 'STABILI') {
                  // setto le altre due tabelle invisibili
                  this.isTablePegGraviAvailable = false;
                  this.isTablePegRemissioneAvailable = false;
                  this.isTablePegModerataAvailable = false;
                  this.isTablePegLieveAvailable = false;
                  this.isTableMiglGraviAvailable = false;
                  this.isTableMiglLieveAvailable = false;
                  this.isTableMiglModerataAvaialble = false;
                  this.isTableMiglRemissioneAvailable = false;
                  this.isTableStabiliLieveAvailable = false;
                  this.isTableStabiliGraviAvailable = false;
                  this.isTableStabiliRemissioneAvailable = false;
                  this.showTableStabiliModerata(); // mostro la tabella
                } else if (this.myChartCrohnStableUnstable.getElementAtEvent(event)[0]['_model'].datasetLabel === 'ATTIVITA LIEVE'
                  && this.myChartCrohnStableUnstable.getElementAtEvent(event)[0]['_model'].label === 'STABILI') {
                  // setto le altre due tabelle invisibili
                  this.isTablePegGraviAvailable = false;
                  this.isTablePegRemissioneAvailable = false;
                  this.isTablePegModerataAvailable = false;
                  this.isTablePegLieveAvailable = false;
                  this.isTableMiglGraviAvailable = false;
                  this.isTableMiglLieveAvailable = false;
                  this.isTableMiglModerataAvaialble = false;
                  this.isTableMiglRemissioneAvailable = false;
                  this.isTableStabiliGraviAvailable = false;
                  this.isTableStabiliModerataAvailable = false;
                  this.isTableStabiliRemissioneAvailable = false;
                  this.showTableStabiliLieve(); // mostro la tabella
                } else if (this.myChartCrohnStableUnstable.getElementAtEvent(event)[0]['_model'].datasetLabel === 'REMISSIONE'
                  && this.myChartCrohnStableUnstable.getElementAtEvent(event)[0]['_model'].label === 'STABILI') {
                  // setto le altre due tabelle invisibili
                  this.isTablePegGraviAvailable = false;
                  this.isTablePegRemissioneAvailable = false;
                  this.isTablePegModerataAvailable = false;
                  this.isTablePegLieveAvailable = false;
                  this.isTableMiglGraviAvailable = false;
                  this.isTableMiglLieveAvailable = false;
                  this.isTableMiglModerataAvaialble = false;
                  this.isTableMiglRemissioneAvailable = false;
                  this.isTableStabiliLieveAvailable = false;
                  this.isTableStabiliGraviAvailable = false;
                  this.isTableStabiliModerataAvailable = false;
                  this.showTableStabiliRemissione(); // mostro la tabella
                } else if (this.myChartCrohnStableUnstable.getElementAtEvent(event)[0]['_model'].datasetLabel === 'ATTIVITA GRAVE'
                  && this.myChartCrohnStableUnstable.getElementAtEvent(event)[0]['_model'].label === 'IN MIGLIORAMENTO') {
                  // setto le altre due tabelle invisibili
                  this.isTablePegGraviAvailable = false;
                  this.isTablePegRemissioneAvailable = false;
                  this.isTablePegModerataAvailable = false;
                  this.isTablePegLieveAvailable = false;
                  this.isTableMiglLieveAvailable = false;
                  this.isTableMiglModerataAvaialble = false;
                  this.isTableMiglRemissioneAvailable = false;
                  this.isTableStabiliLieveAvailable = false;
                  this.isTableStabiliModerataAvailable = false;
                  this.isTableStabiliRemissioneAvailable = false;
                  this.isTableStabiliGraviAvailable = false;
                  this.showTableMiglGrave(); // mostro la tabella
                } else if (this.myChartCrohnStableUnstable.getElementAtEvent(event)[0]['_model'].datasetLabel === 'ATTIVITA MODERATA'
                  && this.myChartCrohnStableUnstable.getElementAtEvent(event)[0]['_model'].label === 'IN MIGLIORAMENTO') {
                  // setto le altre due tabelle invisibili
                  this.isTablePegGraviAvailable = false;
                  this.isTablePegRemissioneAvailable = false;
                  this.isTablePegModerataAvailable = false;
                  this.isTablePegLieveAvailable = false;
                  this.isTableMiglLieveAvailable = false;
                  this.isTableMiglGraviAvailable = false;
                  this.isTableMiglRemissioneAvailable = false;
                  this.isTableStabiliLieveAvailable = false;
                  this.isTableStabiliModerataAvailable = false;
                  this.isTableStabiliRemissioneAvailable = false;
                  this.isTableStabiliGraviAvailable = false;
                  this.showTableMiglModerata(); // mostro la tabella
                } else if (this.myChartCrohnStableUnstable.getElementAtEvent(event)[0]['_model'].datasetLabel === 'ATTIVITA LIEVE'
                  && this.myChartCrohnStableUnstable.getElementAtEvent(event)[0]['_model'].label === 'IN MIGLIORAMENTO') {
                  // setto le altre due tabelle invisibili
                  this.isTablePegGraviAvailable = false;
                  this.isTablePegRemissioneAvailable = false;
                  this.isTablePegModerataAvailable = false;
                  this.isTablePegLieveAvailable = false;
                  this.isTableMiglGraviAvailable = false;
                  this.isTableMiglModerataAvaialble = false;
                  this.isTableMiglRemissioneAvailable = false;
                  this.isTableStabiliLieveAvailable = false;
                  this.isTableStabiliModerataAvailable = false;
                  this.isTableStabiliRemissioneAvailable = false;
                  this.isTableStabiliGraviAvailable = false;
                  this.showTableMiglLieve(); // mostro la tabella
                } else if (this.myChartCrohnStableUnstable.getElementAtEvent(event)[0]['_model'].datasetLabel === 'REMISSIONE'
                  && this.myChartCrohnStableUnstable.getElementAtEvent(event)[0]['_model'].label === 'IN MIGLIORAMENTO') {
                  // setto le altre due tabelle invisibili
                  this.isTablePegGraviAvailable = false;
                  this.isTablePegRemissioneAvailable = false;
                  this.isTablePegModerataAvailable = false;
                  this.isTablePegLieveAvailable = false;
                  this.isTableMiglLieveAvailable = false;
                  this.isTableMiglModerataAvaialble = false;
                  this.isTableMiglGraviAvailable = false;
                  this.isTableStabiliLieveAvailable = false;
                  this.isTableStabiliModerataAvailable = false;
                  this.isTableStabiliRemissioneAvailable = false;
                  this.isTableStabiliGraviAvailable = false;
                  this.showTableMiglRemissione(); // mostro la tabella
                } else if (this.myChartCrohnStableUnstable.getElementAtEvent(event)[0]['_model'].datasetLabel === 'ATTIVITA GRAVE'
                  && this.myChartCrohnStableUnstable.getElementAtEvent(event)[0]['_model'].label === 'IN PEGGIORAMENTO') {
                  // setto le altre due tabelle invisibili
                  this.isTablePegRemissioneAvailable = false;
                  this.isTablePegModerataAvailable = false;
                  this.isTablePegLieveAvailable = false;
                  this.isTableMiglGraviAvailable = false;
                  this.isTableMiglLieveAvailable = false;
                  this.isTableMiglModerataAvaialble = false;
                  this.isTableMiglRemissioneAvailable = false;
                  this.isTableStabiliLieveAvailable = false;
                  this.isTableStabiliModerataAvailable = false;
                  this.isTableStabiliRemissioneAvailable = false;
                  this.isTableStabiliGraviAvailable = false;
                  this.showTablePegGrave(); // mostro la tabella
                } else if (this.myChartCrohnStableUnstable.getElementAtEvent(event)[0]['_model'].datasetLabel === 'ATTIVITA MODERATA'
                  && this.myChartCrohnStableUnstable.getElementAtEvent(event)[0]['_model'].label === 'IN PEGGIORAMENTO') {
                  // setto le altre due tabelle invisibili
                  this.isTablePegRemissioneAvailable = false;
                  this.isTablePegLieveAvailable = false;
                  this.isTablePegGraviAvailable = false;
                  this.isTableMiglGraviAvailable = false;
                  this.isTableMiglLieveAvailable = false;
                  this.isTableMiglModerataAvaialble = false;
                  this.isTableMiglRemissioneAvailable = false;
                  this.isTableStabiliLieveAvailable = false;
                  this.isTableStabiliModerataAvailable = false;
                  this.isTableStabiliRemissioneAvailable = false;
                  this.isTableStabiliGraviAvailable = false;
                  this.showTablePegModerata(); // mostro la tabella
                } else if (this.myChartCrohnStableUnstable.getElementAtEvent(event)[0]['_model'].datasetLabel === 'ATTIVITA LIEVE'
                  && this.myChartCrohnStableUnstable.getElementAtEvent(event)[0]['_model'].label === 'IN PEGGIORAMENTO') {
                  // setto le altre due tabelle invisibili
                  this.isTablePegRemissioneAvailable = false;
                  this.isTablePegModerataAvailable = false;
                  this.isTablePegGraviAvailable = false;
                  this.isTableMiglGraviAvailable = false;
                  this.isTableMiglLieveAvailable = false;
                  this.isTableMiglModerataAvaialble = false;
                  this.isTableMiglRemissioneAvailable = false;
                  this.isTableStabiliLieveAvailable = false;
                  this.isTableStabiliModerataAvailable = false;
                  this.isTableStabiliRemissioneAvailable = false;
                  this.isTableStabiliGraviAvailable = false;
                  this.showTablePegLieve(); // mostro la tabella
                } else if (this.myChartCrohnStableUnstable.getElementAtEvent(event)[0]['_model'].datasetLabel === 'REMISSIONE'
                  && this.myChartCrohnStableUnstable.getElementAtEvent(event)[0]['_model'].label === 'IN PEGGIORAMENTO') {
                  // setto le altre due tabelle invisibili
                  this.isTablePegGraviAvailable = false;
                  this.isTablePegModerataAvailable = false;
                  this.isTablePegLieveAvailable = false;
                  this.isTableMiglGraviAvailable = false;
                  this.isTableMiglLieveAvailable = false;
                  this.isTableMiglModerataAvaialble = false;
                  this.isTableMiglRemissioneAvailable = false;
                  this.isTableStabiliLieveAvailable = false;
                  this.isTableStabiliModerataAvailable = false;
                  this.isTableStabiliRemissioneAvailable = false;
                  this.isTableStabiliGraviAvailable = false;
                  this.showTablePegRemissione(); // mostro la tabella
                } else {
                }
              }
            },
            onHover: (event) => {
              if (this.myChartCrohnStableUnstable.getElementAtEvent(event).length > 0) {
                if (this.myChartCrohnStableUnstable.getElementAtEvent(event)[0]['_model'].datasetLabel === 'ATTIVITA GRAVE' ||
                  this.myChartCrohnStableUnstable.getElementAtEvent(event)[0]['_model'].datasetLabel === 'ATTIVITA MODERATA' ||
                  this.myChartCrohnStableUnstable.getElementAtEvent(event)[0]['_model'].datasetLabel === 'ATTIVITA LIEVE' ||
                  this.myChartCrohnStableUnstable.getElementAtEvent(event)[0]['_model'].datasetLabel === 'REMISSIONE' ) {
                  this.setHoverVariable();
                } else {
                  this.unsetHoverVariable();
                }
              }
            },
            scales: {
              xAxes: [{
                display: true,
                stacked: true,
                ticks: {
                  fontSize: 12,
                  fontStyle: 'bold',
                  fontFamily: 'Helvetica',
                  fontColor: '#006192'
                }
              }],
              yAxes: [{
                display: true,
                stacked: true,
                ticks: {
                  fontSize: 12,
                  fontStyle: 'bold',
                  fontFamily: 'Helvetica',
                  fontColor: '#006192'
                }
              }],
            },
            legend: {
              onHover: (event: MouseEvent, legendItem: Chart.ChartLegendLabelItem) => {
                // tslint:disable-next-line:max-line-length
                if (legendItem.text.length > 0 && (legendItem.text === 'ATTIVITA GRAVE' || legendItem.text === 'ATTIVITA MODERATA'
                  || legendItem.text === 'ATTIVITA LIEVE' || legendItem.text === 'REMISSIONE')) {
                  this.setHoverVariable();
                } else {
                  this.unsetHoverVariable();
                }
              },
              display: true,
              position: 'top',
              align: 'center',
              labels: {
                usePointStyle: true,
                fontColor: '#006192',
                fontSize: 14,
                fontFamily: 'Helvetica',
              }
            },
            tooltips: {
              backgroundColor: '#1c1c1c',
              bodyFontSize: 16,
              titleFontSize: 18,
              cornerRadius: 5,
              caretPadding: 10
            },
            title: {
              display: true,
              text: 'Malattia di Crohn - n° di pazienti stabili e instabili',
              fontColor: '#006192',
              fontSize: 20,
              fontFamily: 'Helvetica',
            },
            hover: {
              mode: 'nearest',
              intersect: true
            }
          }
        });
        this.isDataAvailable = true;

      }, error => {
        if (error.status === 500) {
          localStorage.setItem('expirationTime', '0');
          console.log('SESSIONE SCADUTA');
          location.reload();
        }
      });


  }
  // pagination della tabella di stabili recidiva patients
  // paginazione effettuata manualmente
  getPagination(data) {
    console.log(data);
    this.dataSource = new MatTableDataSource<Patient>();
    // this.dataSource.data = data;
    this.tasks = data;
    this.totalSize = this.tasks.length;
    this.currentPage = 0;
    this.iterator(); // iterator sistema i nomi alla pagina corretta
  }
  handlePage(event?: PageEvent) {
    this.currentPage = event.pageIndex;
    this.pageSize = event.pageSize;
    this.iterator();
  }
  private iterator() {
    const end = (this.currentPage + 1) * this.pageSize;
    const start = this.currentPage * this.pageSize;
    this.dataSource.data = this.tasks.slice(start, end);
  }
  // setta tutte le tabelle a false appena si clicca
  hideAllTable() {
    this.isTablePegGraviAvailable = false;
    this.isTablePegModerataAvailable = false;
    this.isTablePegLieveAvailable = false;
    this.isTablePegRemissioneAvailable = false;
    this.isTableMiglGraviAvailable = false;
    this.isTableMiglLieveAvailable = false;
    this.isTableMiglModerataAvaialble = false;
    this.isTableMiglRemissioneAvailable = false;
    this.isTableStabiliLieveAvailable = false;
    this.isTableStabiliModerataAvailable = false;
    this.isTableStabiliRemissioneAvailable = false;
    this.isTableStabiliGraviAvailable = false;
  }
  // show table stabili recidiva
  showTableStabiliGrave(): void {
    if (this.isHovered === true) {
      this.TableTitle = 'STABILI ATTIVITA GRAVE';
      if (this.isTableStabiliGraviAvailable === true) {
        this.isTableStabiliGraviAvailable = false;
      } else {
        // e' importante prima nascondere tutte le tabelle così che il paginator risulti undefined e si resetti
        this.hideAllTable();
        // temporeggio 200 ms prima di mostrare la nuova tabella per far funzionare il reset
        this.delay(200).then( anything => {
          this.getPagination(this.stabiliGraveCrohn);  // creo la tabella stabili ATTIVITÀ GRAVE
          this.isTableStabiliGraviAvailable = true;
        });
      }
    }
  }
  showTableStabiliModerata(): void {
    if (this.isHovered === true) {
      this.TableTitle = 'STABILI ATTIVITA MODERATA';
      if (this.isTableStabiliModerataAvailable === true) {
        this.isTableStabiliModerataAvailable = false;
      } else {
        // e' importante prima nascondere tutte le tabelle così che il paginator risulti undefined e si resetti
        this.hideAllTable();
        // temporeggio 200 ms prima di mostrare la nuova tabella per far funzionare il reset
        this.delay(200).then( anything => {
          this.getPagination(this.stabiliModerataCrohn);  // creo la tabella stabili ATTIVITÀ GRAVE
          this.isTableStabiliModerataAvailable = true;
        });
      }
    }
  }
  showTableStabiliLieve(): void {
    if (this.isHovered === true) {
      this.TableTitle = 'STABILI ATTIVITA LIEVE';
      if (this.isTableStabiliLieveAvailable === true) {
        this.isTableStabiliLieveAvailable = false;
      } else {
        // e' importante prima nascondere tutte le tabelle così che il paginator risulti undefined e si resetti
        this.hideAllTable();
        // temporeggio 200 ms prima di mostrare la nuova tabella per far funzionare il reset
        this.delay(200).then( anything => {
          this.getPagination(this.stabiliLieveCrohn);  // creo la tabella stabili ATTIVITÀ GRAVE
          this.isTableStabiliLieveAvailable = true;
        });
      }
    }
  }
  showTableStabiliRemissione(): void {
    if (this.isHovered === true) {
      this.TableTitle = 'STABILI REMISSIONE';
      if (this.isTableStabiliRemissioneAvailable === true) {
        this.isTableStabiliRemissioneAvailable = false;
      } else {
        // e' importante prima nascondere tutte le tabelle così che il paginator risulti undefined e si resetti
        this.hideAllTable();
        // temporeggio 200 ms prima di mostrare la nuova tabella per far funzionare il reset
        this.delay(200).then( anything => {
          this.getPagination(this.stabiliRemissioneCrohn);  // creo la tabella stabili ATTIVITÀ GRAVE
          this.isTableStabiliRemissioneAvailable = true;
        });
      }
    }
  }
  // show table in miglioramento recidiva
  showTableMiglGrave(): void {
    if (this.isHovered === true) {
      this.TableTitle = 'IN MIGLIORAMENTO ATTIVITA GRAVE';
      if (this.isTableMiglGraviAvailable === true) {
        this.isTableMiglGraviAvailable = false;
      } else {
        // e' importante prima nascondere tutte le tabelle così che il paginator risulti undefined e si resetti
        this.hideAllTable();
        // temporeggio 200 ms prima di mostrare la nuova tabella per far funzionare il reset
        this.delay(200).then( anything => {
          this.getPagination(this.instabiliMiglGraveCrohn); // creo la tabella instabili in miglioramento
          this.isTableMiglGraviAvailable = true;
        });
      }
    }
  }
  showTableMiglModerata(): void {
    if (this.isHovered === true) {
      this.TableTitle = 'IN MIGLIORAMENTO ATTIVITA MODERATA';
      if (this.isTableMiglModerataAvaialble === true) {
        this.isTableMiglModerataAvaialble = false;
      } else {
        // e' importante prima nascondere tutte le tabelle così che il paginator risulti undefined e si resetti
        this.hideAllTable();
        // temporeggio 200 ms prima di mostrare la nuova tabella per far funzionare il reset
        this.delay(200).then( anything => {
          this.getPagination(this.instabiliMiglModerataCrohn); // creo la tabella instabili in miglioramento
          this.isTableMiglModerataAvaialble = true;
        });
      }
    }
  }
  showTableMiglLieve(): void {
    if (this.isHovered === true) {
      this.TableTitle = 'IN MIGLIORAMENTO ATTIVITA LIEVE';
      if (this.isTableMiglLieveAvailable === true) {
        this.isTableMiglLieveAvailable = false;
      } else {
        // e' importante prima nascondere tutte le tabelle così che il paginator risulti undefined e si resetti
        this.hideAllTable();
        // temporeggio 200 ms prima di mostrare la nuova tabella per far funzionare il reset
        this.delay(200).then( anything => {
          this.getPagination(this.instabiliMiglLieveCrohn); // creo la tabella instabili in miglioramento
          this.isTableMiglLieveAvailable = true;
        });
      }
    }
  }
  showTableMiglRemissione(): void {
    if (this.isHovered === true) {
      this.TableTitle = 'IN MIGLIORAMENTO REMISSIONE';
      if (this.isTableMiglRemissioneAvailable === true) {
        this.isTableMiglRemissioneAvailable = false;
      } else {
        // e' importante prima nascondere tutte le tabelle così che il paginator risulti undefined e si resetti
        this.hideAllTable();
        // temporeggio 200 ms prima di mostrare la nuova tabella per far funzionare il reset
        this.delay(200).then( anything => {
          this.getPagination(this.instabiliMiglRemissioneCrohn); // creo la tabella instabili in miglioramento
          this.isTableMiglRemissioneAvailable = true;
        });
      }
    }
  }
  // show table in peggioramento recidiva
  showTablePegGrave(): void {
    if (this.isHovered === true) {
      this.TableTitle = 'IN PEGGIORAMENTO ATTIVITA GRAVE';
      if (this.isTablePegGraviAvailable === true) {
        this.isTablePegGraviAvailable = false;
      } else {
        // e' importante prima nascondere tutte le tabelle così che il paginator risulti undefined e si resetti
        this.hideAllTable();
        // temporeggio 200 ms prima di mostrare la nuova tabella per far funzionare il reset
        this.delay(200).then( anything => {
          this.getPagination(this.instabiliPegGraveCrohn); // creo la tabella instabili in peggioramento
          this.isTablePegGraviAvailable = true;
        });
      }
    }
  }
  showTablePegModerata(): void {
    if (this.isHovered === true) {
      this.TableTitle = 'IN PEGGIORAMENTO ATTIVITA MODERATA';
      if (this.isTablePegModerataAvailable === true) {
        this.isTablePegModerataAvailable = false;
      } else {
        // e' importante prima nascondere tutte le tabelle così che il paginator risulti undefined e si resetti
        this.hideAllTable();
        // temporeggio 200 ms prima di mostrare la nuova tabella per far funzionare il reset
        this.delay(200).then( anything => {
          this.getPagination(this.instabiliPegModerataCrohn); // creo la tabella instabili in peggioramento
          this.isTablePegModerataAvailable = true;
        });
      }
    }
  }
  showTablePegLieve(): void {
    if (this.isHovered === true) {
      this.TableTitle = 'IN PEGGIORAMENTO ATTIVITA LIEVE';
      if (this.isTablePegLieveAvailable === true) {
        this.isTablePegLieveAvailable = false;
      } else {
        // e' importante prima nascondere tutte le tabelle così che il paginator risulti undefined e si resetti
        this.hideAllTable();
        // temporeggio 200 ms prima di mostrare la nuova tabella per far funzionare il reset
        this.delay(200).then( anything => {
          this.getPagination(this.instabiliPegLieveCrohn); // creo la tabella instabili in peggioramento
          this.isTablePegLieveAvailable = true;
        });
      }
    }
  }
  showTablePegRemissione(): void {
    if (this.isHovered === true) {
      this.TableTitle = 'IN PEGGIORAMENTO REMISSIONE';
      if (this.isTablePegRemissioneAvailable === true) {
        this.isTablePegRemissioneAvailable = false;
      } else {
        // e' importante prima nascondere tutte le tabelle così che il paginator risulti undefined e si resetti
        this.hideAllTable();
        // temporeggio 200 ms prima di mostrare la nuova tabella per far funzionare il reset
        this.delay(200).then( anything => {
          this.getPagination(this.instabiliPegRemissioneCrohn); // creo la tabella instabili in peggioramento
          this.isTablePegRemissioneAvailable = true;
        });
      }
    }
  }
  // set hovered variable
  setHoverVariable(): void {
    this.isHovered = true;
  }
  // unset hovered variable
  unsetHoverVariable(): void {
    this.isHovered = false;
  }
  openPanel(patient) {
    this.router.navigateByUrl('/patient-panel/' + patient.ssn + '/general-status');
  }
  openQuestionnaire(patient) {
    this.router.navigateByUrl('/patient-questionnaires-show/' + patient.ssn + '/hbi' + '/general-status');
  }
  openChat(patient) {
    this.router.navigateByUrl('/doctor-chat/' + patient.ssn + '/general-status');
  }
  async delay(ms: number) {
    await new Promise(resolve => setTimeout(() => resolve(), ms)).then(() => console.log('fired'));
  }

}
